module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "hello"
  }, [_h('h1', [_s(msg)])])
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
 ** module id = 9
 ** module chunks = 1
 **/